import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/blog" as const,
	[Locale.en]: "/blog" as const,
} satisfies LocalizedString;

export function getPostsListingPath(tenant: Tenant, year?: string): string {
	if (year !== undefined) {
		return `${getPostsListingPath(tenant)}/${year}`;
	}
	return getPathInLocale(tenant.locale, pathMap);
}
